import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { earningsApi } from '../../api/earnings';

function moneyOf(minor, currency) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format((Number(minor) || 0) / 100);
}

/**
 * Why no offers come (InGo ADR 0052 §6; Rio, 11 Oct 2026: *"if they have an
 * outstanding balance that is greater or equal to that credit then you won't
 * be given orders"*): the rider owes InGo the credit limit or more, and gets
 * no offers until they pay at the office. Read from `GET rider/me/balance`.
 *
 * Never a block, and never a guess: a balance that could not be read shows
 * nothing, since dispatch, not this notice, decides who is offered work.
 */
export default function CreditLimitNotice({ earnings = earningsApi }) {
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    let cancelled = false;

    earnings.balance().then(
      (answer) => !cancelled && setBalance(answer),
      () => {},
    );

    return () => {
      cancelled = true;
    };
  }, [earnings]);

  if (balance?.over_credit !== true) return null;

  return (
    <p className="dh__alert dh__alert--error" role="alert">
      You owe InGo {moneyOf(balance.owed_minor, balance.currency)}, at or over your credit limit of {moneyOf(balance.credit_limit_minor, balance.currency)}. You
      get no offers until you pay at the InGo office.{' '}
      <Link to="/driver/wallet" style={{ color: 'inherit', fontWeight: 700 }}>
        See your balance
      </Link>
    </p>
  );
}
